import React from 'react';

import Layout from '../components/Layout';
import SEO from '../components/seo';
import notFoundPuppet from '../assets/404_Puppet.svg';
import './404.scss';

const NotFoundPage = () => (
  <Layout className="not-found">
    <SEO title="Arduino: Page Not found" description="Arduino: Page Not found" />
    <div className="notfound">
      <h1>Oops! There’s nothing here</h1>
      <p>
        You can go back, use our search in the top bar, or try looking on our <a href="https://support.arduino.cc">Help Center</a> if you need a hand.
      </p>
      <img src={notFoundPuppet} alt="Not found" />
    </div>
  </Layout>
);

export default NotFoundPage;
